import { getAppVersion } from '@croquiscom/web2app';
import { callDeepLink } from '@croquiscom-pvt/web2app';

export const redirectInquiries = (catalog_product_id: string) => {
  const is_app = Boolean(getAppVersion());
  const url = `${window.location.origin}/inquiries/product/new?product_id=${catalog_product_id}`;
  if (is_app) {
    callDeepLink('/zpay_browser')({
      url: encodeURIComponent(url),
      title: encodeURIComponent('상품 문의'),
    });
  } else {
    window.location.href = url;
  }
};
